import { mountComponents } from './ReactDomHelper';
import { FastighetsMapBlock } from '../fastighetsmapblock';
import { FASTIGHETSMAP } from '../../constants';
export const mountFastighetsMap = () => {
  mountComponents(FASTIGHETSMAP, FastighetsMapBlock);
};
